export var ANALYTICS_HOVER_DELAY = 1000;